import { gql } from '@jetshop/core/gql';
import { productGridDetailsFragment } from '@jetshop/core/data/deprecatedQueries';
export const searchQuery = ({ resultFragment = productGridDetailsFragment, includeFilters = true }) => gql `
  query SearchQuery($term: String!, $limit: Paging, $offset: Int, $filters: FilterInput) {
    search(term: $term) {
      products(paging: { first: $limit, offset: $offset }, filters: $filters) {
        ${includeFilters
    ? ` 
        filters {
          id
          name
          ... on ListFilter {
            items {
              text
              value
              resultCount
            }
          }
          ... on NumericRangeFilter {
            id
            min
            max
            name
          }
          ... on BooleanFilter {
            default
          }
          ... on MultiListFilter {
            lists {
              id
              name
              items {
                value
                resultCount
              }
            }
          }
        }`
    : ''}
        totalResults
        result {
          ${resultFragment}
        }
      }
    }
  }
`;
const autocompleteResultFragment = `
  name
  id
  primaryRoute {
    id
    slug
    path
  }
`;
export const autocompleteQuery = ({ resultFragment = autocompleteResultFragment }) => gql `
  query AutocompleteQuery($term: String!) {
    searchAutoComplete(term: $term) {
      products {
        result {
          ${resultFragment}
        }
      }
    }
  }
`;
//# sourceMappingURL=searchQuery.js.map